import { useCallback } from "react";
import { useACLContext, type CheckOptions } from "../context";
import type { Action, Resource } from "@shield-acl/core";

/**
 * Primitivo do ACL: expõe tudo do contexto (já escopado) + atalhos.
 *
 * @example
 * const { can, scope, setUser } = useAcl()
 * can("update", "posts", { record: post })
 * can("read", "posts", { scope: "app:outro" })   // override de scope
 */
export function useAcl() {
  const ctx = useACLContext();

  const cannot = useCallback(
    (action: Action, resource?: Resource, opts?: CheckOptions) =>
      !ctx.can(action, resource, opts),
    [ctx],
  );

  const clearCache = useCallback(() => ctx.engine.clearCache(), [ctx.engine]);

  return { ...ctx, cannot, clearCache };
}
